import FormValidationError from './FormValidationError';
export default class FormFieldValidationError extends FormValidationError {
    constructor({ htmlName, name, message, hint, index, }) {
        super({
            message,
            hint,
        });
        this.htmlName = htmlName;
        this.name = name;
        this.index = index;
    }
}
